import { FILTERED_ITEM_DATA } from "../types";

export const setFilteredItemData = (data) => ({
    type: FILTERED_ITEM_DATA,
    payload: data
})
